import { render, staticRenderFns } from "./EditShipment.vue?vue&type=template&id=736bbf00&scoped=true"
import script from "./EditShipment.vue?vue&type=script&lang=js"
export * from "./EditShipment.vue?vue&type=script&lang=js"
import style0 from "./EditShipment.vue?vue&type=style&index=0&id=736bbf00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736bbf00",
  null
  
)

export default component.exports